import { LE_CONTRACTED_HOTEL_TYPES } from 'constants/offer'

export const SEASONAL_CAROUSEL_LIMIT = 20

const SUPPORTED_MARKETS = new Set([
  'DE', 'FR', 'ES', 'IT', 'NL', 'IE', 'GB', 'CA', 'IN', 'ZA', 'HK', 'KR', 'JP', 'AE', 'MY', 'ID', 'TH',
])

export function isSeasonalCarouselMarket(region: string): boolean {
  return SUPPORTED_MARKETS.has(region)
}

// Display context only; LERE owns candidate selection and ranking.
export const SEASONAL_CAROUSEL_FILTERS: App.OfferListFilters = {
  offerTypes: LE_CONTRACTED_HOTEL_TYPES,
  rooms: [{ adults: 2, children: 0 }],
  limit: SEASONAL_CAROUSEL_LIMIT,
}

export function selectSeasonalCarouselOfferIds(
  offerIds: Array<string>,
  heroOfferIds: Array<string> | undefined,
  unavailableOfferIds?: ReadonlySet<string>,
): Array<string> {
  // Undefined is unpublished; an empty array is a settled hero with no offers.
  if (!heroOfferIds) return []
  return offerIds.filter(id => !heroOfferIds.includes(id) && !unavailableOfferIds?.has(id)).slice(0, SEASONAL_CAROUSEL_LIMIT)
}
